import api from './axios';
import type { AuthUser, LoginResponse, SsoStatus } from '@/types/api.types';

const BASE = import.meta.env.VITE_API_URL || '/api/v1';
/** Full-page navigation target (the backend redirects to Entra ID). */
export const ssoLoginUrl = `${BASE}/auth/sso/login`;

export const authApi = {
  ssoStatus: (): Promise<SsoStatus> => api.get('/auth/sso/status'),
  me: (): Promise<AuthUser> => api.get('/auth/me'),
  devLogin: (email: string, role: 'AGENT' | 'ADMIN'): Promise<LoginResponse> => api.post('/auth/dev-login', { email, role }),
  logout: (refreshToken: string): Promise<void> => api.post('/auth/logout', { refreshToken }),
};
